type LoadedProfileLanguage = {
    id: string;
    preferred_language_tag?: string | null;
};

type ProfileLanguageResult = {
    data: { preferred_language_tag?: string | null } | null;
    error: { message?: string } | null;
};

export type ProfileLanguageClient = {
    from(table: 'profiles'): {
        select(columns: 'preferred_language_tag'): {
            eq(column: 'id', value: string): {
                maybeSingle(): PromiseLike<ProfileLanguageResult>;
            };
        };
    };
};

export type ResolveEnqueuePreferenceInput = {
    client: ProfileLanguageClient;
    userId: string;
    loadedProfile?: LoadedProfileLanguage | null;
};

/**
 * Resolve profile language evidence before creating immutable email work.
 *
 * Session profile loading is asynchronous. If it has not completed for this
 * user, read only the preference rather than permanently freezing a device
 * locale into the new job.
 */
export async function resolveEnqueuePreferredLanguageTag({
    client,
    userId,
    loadedProfile,
}: ResolveEnqueuePreferenceInput): Promise<string | null> {
    if (loadedProfile?.id === userId) {
        return loadedProfile.preferred_language_tag ?? null;
    }

    const { data, error } = await client
        .from('profiles')
        .select('preferred_language_tag')
        .eq('id', userId)
        .maybeSingle();
    if (error) {
        throw new Error('Could not resolve profile language before queueing email work');
    }
    return data?.preferred_language_tag ?? null;
}
